var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _ellipse4, _rect2, _ellipse5, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polyline, _polyline2, _polyline3, _polygon, _polygon2, _polyline4, _polyline5, _polyline6, _polygon3, _polygon4, _path27, _path28, _path29, _path30, _path31, _ellipse6, _polyline7, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _polygon5, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _ellipse7, _polyline8, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _polygon6, _path61, _path62, _path63, _path64, _path65, _path66, _polyline9, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _circle, _path83, _path84, _path85, _path86, _path87, _ellipse8, _ellipse9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 92.37,
    y1: 159.78,
    x2: 119.91,
    y2: 130.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd6f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#532a12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 201.12,
    y1: 217.43,
    x2: 225.84,
    y2: 143.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 36.66,
    y1: 192.48,
    x2: 55.37,
    y2: 172.89,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.23,287.42,13.5,181.2C7.78,178,2.87,172.71,8.45,169.25l180.37-104c2.71-1.68,6.82-2.78,9.57-1.18L387,173.61c5.72,3.32,6.75,12.6,1,15.93L216.92,287.25A23.9,23.9,0,0,1,193.23,287.42Z",
    fill: "#dd6f31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.37,172.75c4.42-2.71,25.44-16.1,29.78-18.92C141.59,149,151.09,142,151.09,142L103.7,119.73,63.94,145.84c7.2,3.77,28.91,29.79,32.51,31.8C98.06,176.69,102.79,173.72,104.37,172.75Z",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.59,236.52c15-8.07,61.1-45.06,62-47.66L221,156.26l-73.43,38.81C163.24,203.28,187.92,223.11,209.59,236.52Z",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240,147.11l-19,9.15a4.38,4.38,0,0,0-.31,7.72l45.06,26.28a4.38,4.38,0,0,0,5.89-1.41l10.95-17",
    fill: "#56403d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335.49,98.39,180.3,9a5,5,0,0,0-7.57,4.37v95a3.89,3.89,0,0,0,1.95,3.37l165.18,95.35a1.88,1.88,0,0,0,2.82-1.63V110.82A14.35,14.35,0,0,0,335.49,98.39Z",
    fill: "#68e1fd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183,17.39,330,102a10.31,10.31,0,0,1,5.17,8.93V179a3.72,3.72,0,0,1-5.57,3.23l-149.91-86A3.67,3.67,0,0,1,177.83,93V20.39A3.45,3.45,0,0,1,183,17.39Z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.42,
    cy: 145.54,
    rx: 1.6,
    ry: 0.01,
    transform: "translate(-23.08 49.24) rotate(-10.9)",
    fill: "#ab643c"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 324.01,
    cy: 104.06,
    rx: 1.6,
    ry: 1.74,
    fill: "#659fe4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.91,
    cy: 101.52,
    rx: 1.6,
    ry: 1.74,
    fill: "#c5e9ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.72,34.95l35.42,18.94c1.7.91,3.22-1.68,1.51-2.59L186.24,32.36c-1.7-.91-3.22,1.68-1.51,2.59Z",
    fill: "#00a99d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.15,200.47q6.63-4.07,13.16-8.3c7.43-4.83,10.59-5.76,17.5-11.53l-29.65-13L16.76,183.12c7.2,3.77,25.8,15.35,29.39,17.35C47.76,199.53,44.56,201.45,46.15,200.47Z",
    fill: "url(#linear-gradient-3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.92,126.43c-13.66,0-24.74,3.62-24.74,8.09H86.66C86.66,130,75.59,126.43,61.92,126.43Z",
    fill: "#0a1d23"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.26,135.14l-.08-.63A2.74,2.74,0,0,0,37.26,135.14Z",
    fill: "#06489e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.66,134.52l-.1.71A2.76,2.76,0,0,0,86.66,134.52Z",
    fill: "#06489e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.92,142.6c12.93,0,23.54-3.24,24.64-7.38l.1-.71H37.18l.08.63C38.24,139.31,48.9,142.6,61.92,142.6Z",
    fill: "#0a1d23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.81,
    y: 92.76,
    width: 5.57,
    height: 57.42,
    fill: "#25b000"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.6,
    cy: 92.76,
    rx: 2.78,
    ry: 1.18,
    fill: "#25b000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.49,
    y: 102.58,
    width: 5.57,
    height: 57.42,
    transform: "translate(27.79 -12.4) rotate(11.54)",
    fill: "#ff8f02"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.02,
    cy: 103.16,
    rx: 1.18,
    ry: 2.78,
    transform: "translate(-36.26 161.9) rotate(-78.46)",
    fill: "#ff8f02"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2,135.78l-5.08,2.91a.45.45,0,0,1-.45-.78l5.2-3a.46.46,0,0,1,.16-.06l-1-5.5L48.9,132.3a.45.45,0,0,1-.45-.78l5.2-3a.45.45,0,0,1,.19-.06l-.94-5.09-5,2.87a.45.45,0,0,1-.45-.78l5.2-3,.1,0-1.05-5.67-5,2.86a.45.45,0,0,1-.45-.78l5.2-3,.08,0-1-5.54-5.08,2.91a.45.45,0,0,1-.45-.78l5.2-3a.46.46,0,0,1,.16-.06l-.89-4.81-5.09,2.91a.45.45,0,0,1-.45-.78l5.2-3a.46.46,0,0,1,.17-.06l-.89-4.8-5.08,2.9a.45.45,0,0,1-.45-.78l5.2-3A.46.46,0,0,1,48.2,98l-1-5.28-5,2.87a.45.45,0,0,1-.45-.78l5.2-3,.1,0-.46-2.46-11,6.84s7.84,43.65,8,43.74c4.58,2.39,12.91,2.67,12.91,2.67Z",
    fill: "#68e1fd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.74,94.83a.45.45,0,0,0,.45.78l5-2.87L47,91.81l-.1,0Z",
    fill: "#ca4300"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.84,101a.45.45,0,0,0,.45.78l5.08-2.9L48.2,98a.46.46,0,0,0-.15.05Z",
    fill: "#ca4300"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.89,106.76a.45.45,0,0,0,.45.78l5.09-2.91-.17-.9a.46.46,0,0,0-.17.06Z",
    fill: "#ca4300"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45,112.46a.45.45,0,0,0,.45.78l5.08-2.91-.17-.9a.46.46,0,0,0-.16.06Z",
    fill: "#ca4300"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.23,118.88a.45.45,0,0,0,.45.78l5-2.86-.17-.93-.08,0Z",
    fill: "#ca4300"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.43,125.49a.45.45,0,0,0,.45.78l5-2.87-.17-.92-.1,0Z",
    fill: "#ca4300"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.65,128.55l-5.2,3a.45.45,0,0,0,.45.78L54,129.38l-.17-.89A.45.45,0,0,0,53.65,128.55Z",
    fill: "#ca4300"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.67,137.9a.45.45,0,0,0,.45.78l5.08-2.91-.17-.9a.46.46,0,0,0-.16.06Z",
    fill: "#ca4300"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.29,102.6s.28,1.46,2.49,1.71,3-.6,3-.6l-.72-11Z",
    fill: "#ffd8bd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83,92.76l-2.2,4.57a2,2,0,0,0,2.52.35Z",
    fill: "#653200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.81,92.42s.51,1.4,2.73,1.3,2.83-1.06,2.83-1.06L68.94,82Z",
    fill: "#ffd8bd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.94,82l-1.45,4.86A2,2,0,0,0,70,86.77Z",
    fill: "#653200"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.92,142.6c-13,0-23.68-3.29-24.66-7.46.65,5,5.09,39.32,5.26,39.52,0,0,2.27,9.68,19.4,9.67,14.57,0,18.73-7.32,18.73-7.32l5.91-41.79C85.46,139.36,74.85,142.6,61.92,142.6Z",
    fill: "#173743"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "107.3 53.16 98.43 57.89 122.64 80.69 143.99 87.39 151.09 77.75",
    fill: "#ffe8bc"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "140.72 82.54 148.95 77.85 107.3 53.16 108.28 52.59 151.09 77.75 151.09 142 141.75 147.32 138.19 143.6",
    fill: "#68e1fd"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "140.72 82.54 148.95 77.85 107.3 53.16 108.28 52.59 151.09 77.75 151.09 142 141.75 147.32 138.19 143.6",
    fill: "#1371a5",
    opacity: 0.42
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "98.43 57.89 141.75 83.14 141.75 147.32 97.75 121.02 98.43 57.89",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.12 78.93 137.47 80.61 137.47 94.29 135.79 92.14 134.61 93.47 134.61 78.98 137.09 77.2 140.12 78.93",
    fill: "#e85858"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "95.18 71.59 87.27 75.81 108.85 96.13 127.87 102.11 134.21 93.52",
    fill: "#ffe8bc"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "124.96 97.78 132.3 93.61 95.18 71.59 96.05 71.09 134.21 93.52 134.21 150.78 125.88 155.52 122.71 152.21",
    fill: "#68e1fd"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "124.96 97.78 132.3 93.61 95.18 71.59 96.05 71.09 134.21 93.52 134.21 150.78 125.88 155.52 122.71 152.21",
    fill: "#1371a5",
    opacity: 0.42
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.27 75.81 125.88 98.32 125.88 155.52 86.66 132.08 87.27 75.81",
    fill: "#68e1fd"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.42 94.57 122.07 96.06 122.07 108.25 120.57 106.34 119.52 107.52 119.52 94.61 121.72 93.03 124.42 94.57",
    fill: "#e85858"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M141.93,230s-.47,3.66.07,3.88a4.88,4.88,0,0,0,3.26.65,44.92,44.92,0,0,1,4.91-1.29c2-.29,7.18.32,8.07-1.06s0-4.25,0-4.25",
    fill: "#ffe0de"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M158.23,227.95c-.4-2.23-3.7-1.3-5.25-2.31-2.85-1.84-3-5.89-2.74-8.92l-6.34-2.2-1.25,7.28-.72,8.24a3.42,3.42,0,0,0,2.83,1.44l4.23-.94C151.68,230.29,158.51,229.51,158.23,227.95Z",
    fill: "#56403d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.77,234.35s-.47,3.66.07,3.88a4.88,4.88,0,0,0,3.26.65,44.92,44.92,0,0,1,4.91-1.29c2-.29,7.18.32,8.07-1.06s0-4.25,0-4.25",
    fill: "#ffe0de"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M167.07,232.26c-.4-2.23-3.7-1.3-5.25-2.31-2.85-1.84-3-5.89-2.74-8.92l-6.34-2.2-1.25,7.28-.72,8.24a3.42,3.42,0,0,0,2.83,1.44l4.23-.94C160.52,234.6,167.35,233.83,167.07,232.26Z",
    fill: "#56403d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.61,210,140,218.55s2.46,2.53,10.75,2.23,0-15.14,0-15.14",
    fill: "#e85b5b"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.85,
    cy: 229.95,
    rx: 11.8,
    ry: 4.38,
    fill: "#56403d"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "128.86 210.34 129.32 227.99 132.84 227.99 132.84 210.34",
    fill: "#56403d"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M153.54,184.87q-5.3,1.16-10.69,1.79a.6.6,0,0,0-.41.22q-.62-1.86-1.06-3.79c-.16-.73-1.28-.42-1.12.31a40.46,40.46,0,0,0,2.93,8.45c.32.68,1.32.09,1-.59-.53-1.13-1-2.27-1.43-3.44h.08q5.54-.65,11-1.84C154.58,185.83,154.27,184.71,153.54,184.87Z",
    fill: "#008074"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M144,193.06a15.6,15.6,0,0,1-3.58,4.11c-.58.47.25,1.29.82.82a16.5,16.5,0,0,0,3.76-4.34A.58.58,0,0,0,144,193.06Z",
    fill: "#008074"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M136.76,189.28s9.25-7.42,15.39-8.3,9.35,5.79,8.91,10.25-15.14,6.9-15.14,6.9",
    fill: "#edbab9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M141.69,191.75c1.2-1.11,16.9-8.44,22.43-5.09s5.18,5.82,4.48,9.9-6,26-6,26a20,20,0,0,1-12.56.59l1.55-16.31-20.92-11.42",
    fill: "#ff7e7b"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25,165.51c.83.61,8,1.47,9.5,4.78s3.78,20.34,3.78,20.34-4.3,6.41-11.75,4.13c-2.21-.68-13.67-21.63-14-23.8C117,165.3,130.25,165.51,130.25,165.51Z",
    fill: "#fcca4c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M116.11,202.32a18.76,18.76,0,0,1-.89-2.65c-1.76-6.89-2.91-32.76,8.72-31.7,12.76,1.15,8.45,33.1,21.38,32.12s18.23,2.38,12.94,7.39C147.69,217.49,122.59,217.72,116.11,202.32Z",
    fill: "#68e1fd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M134.83,156.28c.08.52,1,7.93-1.19,9.6s-7.12-2.27-7.24-4.23-1.79-6,.31-7.06S134.24,152.62,134.83,156.28Z",
    fill: "#ffe0de"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133,151.08l-.25-.16c-2.81-1.65-7.44-1.24-9.77,1.13a11.62,11.62,0,0,0-1.62,2.24,16.83,16.83,0,0,1-1.13,1.73,11.26,11.26,0,0,0,3.15,8,13.24,13.24,0,0,0,6.71,2.05c.92-2.75-.41-5.88.9-8.64a6.3,6.3,0,0,1,2.92-2.82A6.24,6.24,0,0,0,133,151.08Z",
    fill: "#e0902f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M132.13,161.4a3.09,3.09,0,0,0-1.72-1.83c-.73-.3-1.73-.39-2.17.41-1,1.77,1.42,3,2.7,3.5.6.23.86-.74.27-1l-.21-.08h.07a.45.45,0,0,0,.48-.46C131.88,162.06,132.28,161.82,132.13,161.4Z",
    fill: "#ffe0de"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.6 158.32 172.23 171.24 168.81 185.79 149.54 172.63 151.6 158.32",
    fill: "#68e1fd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M149.54,172.62S139,177.87,139.13,178,157.75,192,157.75,192l11.06-6.18Z",
    fill: "#3129a3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M154,183.73s2.8-2.51,3.22-2.71a2.12,2.12,0,0,1,1.82.51c.45.42,1.08.27,1.58.81s1.77,2.44,1.41,2.94-1.37-.71-1.71-1,0,1-.48,1.77-3.39,1.5-4.17,1.35",
    fill: "#ffe0de"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M140.22,172.62s3.43,11.71,5.44,11.75,8.32-2.09,8.32-2.09,2.72,2.78,2.41,4.54-11.49,8-16.16,6.86-6.93-17.28-6.83-17.59S140.22,172.62,140.22,172.62Z",
    fill: "#fcca4c"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M152.16,176.73a15.26,15.26,0,0,0-1.71-1.12c-.52-.24-1-.51-1.46-.77a1.77,1.77,0,0,0-1.39-.22A36.33,36.33,0,0,0,144.7,177c-.56.4-1.13.79-1.72,1.16a.5.5,0,0,0,.39.91c.29-.07.57-.16.85-.26a3.88,3.88,0,0,0,0,.53,2.55,2.55,0,0,0,.32,1.77.48.48,0,0,0,.14.17l-.37.14c-.6.22-.34,1.19.27,1l3.44-1.26a4.86,4.86,0,0,0,2.21-1.26.5.5,0,0,0-.49-.84c-.25.06-.49.14-.73.22.55-.75,1.39-1.65,1.68-1.4a2,2,0,0,0,2.3.08C153.53,177.42,152.57,177,152.16,176.73Z",
    fill: "#ffe0de"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68,177.1s-3.57.47-6.24.54c-1.09,1.48-2.08,3-3,4.6.2,1,.28,2,.5,3a2.13,2.13,0,0,1,0,.58c4.75-.78,9.81-2.74,10.22-3.79C146.8,180.35,144.68,177.1,144.68,177.1Z",
    fill: "#fcca4c"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M125.23,154a2.24,2.24,0,0,0-1.7-1.68c-2.48-.66-5.75.85-6.49,3.41a5.29,5.29,0,0,0,4.07,6.27,5,5,0,0,0,5.44-4.92A4.33,4.33,0,0,0,125.23,154Z",
    fill: "#cc781d"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M210.49,246.48c0,.42-.33,5.44.23,6s2,3.42,3.85,3.55,3.51-.24,3.85,1.71-10.32,2.61-10.32,2.61-1.12-4.46-1.6-4.33S206,261,206,261l-2,.42-2-1.32.8-8.56,1.29-7.27",
    fill: "#3129a3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M218.48,253.66c-.26,3-.11,7.08,2.74,8.92,1.56,1,4.85.08,5.25,2.31.35,1.95-10.31,2.67-10.31,2.67s-1.15-4.46-1.63-4.32-.43,4.93-.43,4.93l-2,.44-2-1.31.75-8.56,1.25-7.28",
    fill: "#3129a3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M201,242.61l-1.57,8.56s2.46,2.53,10.75,2.23,0-15.14,0-15.14",
    fill: "#edbab9"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.26,
    cy: 262.58,
    rx: 11.8,
    ry: 4.38,
    fill: "#56403d"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "188.27 242.96 188.73 260.61 192.25 260.61 192.25 242.96",
    fill: "#56403d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M213,217.49q-5.3,1.16-10.69,1.79a.6.6,0,0,0-.41.22q-.62-1.86-1.06-3.79c-.16-.73-1.28-.42-1.12.31a40.46,40.46,0,0,0,2.93,8.45c.32.68,1.32.09,1-.59-.53-1.13-1-2.27-1.43-3.44h.08q5.54-.65,11-1.84C214,218.45,213.69,217.33,213,217.49Z",
    fill: "#008074"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M203.41,225.68a15.6,15.6,0,0,1-3.58,4.11c-.58.47.25,1.29.82.82a16.5,16.5,0,0,0,3.76-4.34A.58.58,0,0,0,203.41,225.68Z",
    fill: "#008074"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M196.17,221.9s9.25-7.42,15.39-8.3,9.35,5.79,8.91,10.25-15.14,6.9-15.14,6.9",
    fill: "#edbab9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M201.1,224.37c1.2-1.11,16.9-8.44,22.43-5.09s5.18,5.82,4.48,9.9-6,26-6,26a20,20,0,0,1-12.56.59L211,239.5,190,228.07",
    fill: "#ffe0de"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M189.66,198.14c.83.61,8,1.47,9.5,4.78s3.78,20.34,3.78,20.34-4.3,6.41-11.75,4.13c-2.21-.68-13.67-21.63-14-23.8C176.4,197.92,189.66,198.14,189.66,198.14Z",
    fill: "#006d29"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M175.52,234.94a18.76,18.76,0,0,1-.89-2.65c-1.76-6.89-2.91-32.76,8.72-31.7,12.76,1.15,8.45,33.1,21.38,32.12s18.23,2.38,12.94,7.39C207.1,250.11,182,250.34,175.52,234.94Z",
    fill: "#68e1fd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M194.24,188.9c.08.52,1,7.93-1.19,9.6s-7.12-2.27-7.24-4.23-1.79-6,.31-7.06S193.65,185.24,194.24,188.9Z",
    fill: "#ffe0de"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M192.15,183.55c-2.81-1.65-7.44-1.24-9.77,1.13a11.62,11.62,0,0,0-1.62,2.24,16.83,16.83,0,0,1-1.13,1.73,11.26,11.26,0,0,0,3.15,8,12.79,12.79,0,0,0,7.93,2c-.24-1-.45-2-.61-3-.26-1.63-.65-3.62.56-5a1.7,1.7,0,0,1,1.73-.58l.08-.05,2.4.15A5.44,5.44,0,0,0,192.15,183.55Z",
    fill: "#e0902f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M180.71,188c-2.67-4.8-10.76-2.44-11.36,2.64a10,10,0,0,0,1.83,6.85c1.92,2.4,2,7.75-1.32,11.65s-.61,8.59,3.24,10.25S185.29,221,185,214.26s-8.42-15.35-8.3-20,4.8-2,4.8-2",
    fill: "#e0902f"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M182,188.19a2,2,0,0,0-2-2,2.05,2.05,0,0,0-2,2,18.75,18.75,0,0,0-.06,2.41,2,2,0,0,0,4,0A18.75,18.75,0,0,1,182,188.19Z",
    fill: "#3129a3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.54,194a3.09,3.09,0,0,0-1.72-1.83c-.73-.3-1.73-.39-2.17.41-1,1.77,1.42,3,2.7,3.5.6.23.86-.74.27-1l-.21-.08h.07a.45.45,0,0,0,.48-.46C191.29,194.68,191.69,194.44,191.54,194Z",
    fill: "#ffe0de"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "211.01 190.94 231.64 203.86 228.22 218.41 208.95 205.25 211.01 190.94",
    fill: "#68e1fd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M208.95,205.25s-10.53,5.25-10.41,5.39,18.62,13.95,18.62,13.95l11.06-6.18Z",
    fill: "#3129a3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M213.38,216.35s2.8-2.51,3.22-2.71a2.12,2.12,0,0,1,1.82.51c.45.42,1.08.27,1.58.81s1.77,2.44,1.41,2.94-1.37-.71-1.71-1,0,1-.48,1.77-3.39,1.5-4.17,1.35",
    fill: "#ffe0de"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M199.63,205.25S203.06,217,205.06,217s8.32-2.09,8.32-2.09,2.72,2.78,2.41,4.54-11.49,8-16.16,6.86-6.93-17.28-6.83-17.59S199.63,205.25,199.63,205.25Z",
    fill: "#006d29"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M211.57,209.35a15.26,15.26,0,0,0-1.71-1.12c-.52-.24-1-.51-1.46-.77a1.77,1.77,0,0,0-1.39-.22,36.33,36.33,0,0,0-2.91,2.42c-.56.4-1.13.79-1.72,1.16a.5.5,0,0,0,.39.91c.29-.07.57-.16.85-.26a3.88,3.88,0,0,0,0,.53,2.55,2.55,0,0,0,.32,1.77.48.48,0,0,0,.14.17l-.37.14c-.6.22-.34,1.19.27,1l3.44-1.26a4.86,4.86,0,0,0,2.21-1.26.5.5,0,0,0-.49-.84c-.25.06-.49.14-.73.22.55-.75,1.39-1.65,1.68-1.4a2,2,0,0,0,2.3.08C212.94,210,212,209.6,211.57,209.35Z",
    fill: "#ffe0de"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M204.09,209.72s-3.57.47-6.24.54c-1.09,1.48-2.08,3-3,4.6.2,1,.28,2,.5,3a2.13,2.13,0,0,1,0,.58c4.75-.78,9.81-2.74,10.22-3.79C206.21,213,204.09,209.72,204.09,209.72Z",
    fill: "#006d29"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M250.2,79.78l-5.39-1.05-.08.21a3.84,3.84,0,0,0-1-.41,2.11,2.11,0,0,0-2.56,1.33,1.78,1.78,0,0,0,0,1.26,1.85,1.85,0,0,0-.52,1.34,2.06,2.06,0,0,0,.56,1.42,1.6,1.6,0,0,0,.26,1.91,4.51,4.51,0,0,0,2.27,1c1.42,2.78,4.86,6.45,5.91,5.87,1.37-.76,3.36-4.35,3.36-4.35Z",
    fill: "#e89c89"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "248.8 81.69 224.22 45.83 223.25 46.25 249.7 89.04",
    fill: "#935a4e"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M254.94,87.59S254,80,252.58,79.14s-6.07-2.78-6.94-1.77-1.67,3-.83,3.79S247.27,80,247.27,80l1.41,1s-1.84,1.59-1.73,5.38a9.76,9.76,0,0,0,2.75,6.29Z",
    fill: "#ffb7a2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M274.19,123.12l-2.37-35.53c-1,.87-4.3,21-5.94,34.7C268.66,122.44,271.42,122.77,274.19,123.12Z",
    fill: "#27d9d3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M328.4,87.18l.6-1.08a1,1,0,0,1-.41-1.24c.51-1.17,1.05-2.32,1.59-3.48a.94.94,0,0,1,0-.43,26,26,0,0,0,.88-8c-.23-2.16-.88-4.23-1.09-6.39-.08-.77.81-1,1.38-.79a2.23,2.23,0,0,1,1.09,1.15,7.47,7.47,0,0,1,1.25,3.26,5,5,0,0,1,.37-1.46q.22-.88.43-1.76a12.87,12.87,0,0,1,.92-2.7c.41-.81,1.33-1.18,1.79-.65.7.8,0,2.25-.11,3.18s-.28,1.75-.52,2.69c.36-.87,1.1-2.39,1.58-3.44.37-.81,1.42-3.45,2.58-3.09s.61,2.16.29,3l-.91,2.45c-.27.73-.57,1.68-.88,2.35,0,0,1.22-1.78,1.83-2.73.49-.75,1-1.84,2.11-1.51.71.22.66,1.27.33,1.9-.88,1.67-1.86,3.27-2.88,4.84.66-.61,1.29-1.24,2-1.83a1,1,0,0,1,1.56.8.79.79,0,0,1-.14.49l-8.44,12.13a17.75,17.75,0,0,1-3.43,5.22c-.81.85-2.11-.44-1.29-1.29l.11-.13a.91.91,0,0,1-.08-.14,1,1,0,0,1-.65-.49l-.06,0a.92.92,0,0,1-.29.13A.91.91,0,0,1,328.4,87.18Z",
    fill: "#ffb7a2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M334.9,70.92a5.53,5.53,0,0,1,2.07,4.8c0,.41-.68.42-.65,0a4.94,4.94,0,0,0-1.88-4.35C334.11,71.12,334.57,70.67,334.9,70.92Z",
    fill: "#42342d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M335.79,69.93q.7-2.55,1.17-5.16c.07-.41.7-.24.62.17q-.47,2.6-1.17,5.16A.32.32,0,0,1,335.79,69.93Z",
    fill: "#42342d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M338.52,71.36a37.08,37.08,0,0,0,2.13-5.87.32.32,0,0,1,.62.17,38.1,38.1,0,0,1-2.19,6C338.9,72.07,338.35,71.74,338.52,71.36Z",
    fill: "#42342d"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M339.53,73.9A24.35,24.35,0,0,0,343,68.66c.18-.37.74,0,.56.33A25,25,0,0,1,340,74.36C339.71,74.68,339.25,74.22,339.53,73.9Z",
    fill: "#42342d"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M310.32,150.91A129.2,129.2,0,0,0,301,128l-25.52-.24c-.56,3.48-1.56,6.88-2.18,10.41a51.36,51.36,0,0,0-.74,11.37c7.21,4.06,16.68,9.57,23.53,13.51l19,10.9C313.48,166.39,312.43,158.38,310.32,150.91Z",
    fill: "#159e97"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M302.32,105.15q-.56-8.4-1.57-16.78c-3.19-3.95-7.57-7-12.38-7.64s-11.82.62-15.1,4.49c-3.1,3.69-2.58,9-2.39,13.43.11,2.7.25,5.4.4,8.1,1.41,7.25,3.45,14.36,3.88,21.76,7.09,3.32,17.79,1.62,25.8-.54C301.43,120.36,302,112.76,302.32,105.15Z",
    fill: "#27d9d3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M289,81.47a22.78,22.78,0,0,1,10.81,3.36c2.48,1.62,3.9,4.24,6.58,5.58,3.6,1.81,8.88,1.79,11.84-1.26a65.83,65.83,0,0,0,4.5-5.49c1.11-1.42,5.67-8.82,8.07-7.91,2.81,1.06,6.86,5,7,7.25s-11.72,25.68-22.23,27.33a28,28,0,0,1-18.78-4.16",
    fill: "#27d9d3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M291.58,77.36v6.71a13.67,13.67,0,0,1-8.1,0V78",
    fill: "#fcaa97"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M271.33,108s-14.61-20.89-16.39-20.39-7.42,3.29-7,5.55,11.94,35.48,27.65,33.55",
    fill: "#27d9d3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M291.73,80.2a11.25,11.25,0,0,1-2.23,3.44c-1,1.13-2.44.76-4,.85l1.06,8.19,7.09-10Z",
    fill: "#159e97"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M285.46,84.49,282,92.09,281.46,85l2.31-4.6S283,84.28,285.46,84.49Z",
    fill: "#159e97"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M277.56,62c-.47.12-3.44,20.1,4.85,20.26s9.89-6.36,10.14-8-2.39-6.74-3.2-8.64S279.59,61.45,277.56,62Z",
    fill: "#ffb7a2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M276.53,59.93c2.5-4.51,12.18-5.54,18.91.64a9.89,9.89,0,0,1,2.72,6.78,14.21,14.21,0,0,1-8,11.81s0,0,0-.08,0-.25.07-.37,0-.18.05-.27c.71-3.49.55-7.89-1.1-11s-5-4-8.25-4.55a10.33,10.33,0,0,0-3.23-.32l-1.07,5.13A6.92,6.92,0,0,1,276.53,59.93Z",
    fill: "#edb033"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.32,
    cy: 62.39,
    r: 6.38,
    transform: "translate(218.19 358.66) rotate(-86.02)",
    fill: "#edb033"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M276.59,66.08h7.86l.73-2.36.68,2.93,2.24.14s.11,12.07,1.83,12.34,4.13-4.92,4.39-8-1.41-9.57-7.08-11.33C280.1,57.64,276.92,60.49,276.59,66.08Z",
    fill: "#edb033"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M272,95.94c.06-.68-1-.67-1.05,0-1.08,11.71,4.05,22.75,4.42,34.36,0,.68,1.08.68,1.05,0C276,118.69,270.89,107.64,272,95.94Z",
    fill: "#159e97"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M304.38,108.58a12.67,12.67,0,0,1-6.23-3.12c-.5-.46-1.25.29-.75.75a13.7,13.7,0,0,0,6.7,3.39C304.76,109.73,305,108.71,304.38,108.58Z",
    fill: "#159e97"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M184.72,47.37l35.42,18.94c1.7.91,3.22-1.68,1.51-2.59L186.24,44.78c-1.7-.91-3.22,1.68-1.51,2.59Z",
    fill: "#00a99d"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M184.72,59.36,220.14,78.3c1.7.91,3.22-1.68,1.51-2.59L186.24,56.77c-1.7-.91-3.22,1.68-1.51,2.59Z",
    fill: "#00a99d"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.74,
    cy: 84.3,
    rx: 7.16,
    ry: 11.26,
    transform: "translate(-16.81 65.72) rotate(-18.56)",
    fill: "#68e1fd"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.62,
    cy: 95.44,
    rx: 7.16,
    ry: 11.26,
    transform: "translate(-19.32 72.62) rotate(-18.56)",
    fill: "#68e1fd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImage);
export default __webpack_public_path__ + "static/media/homeImage.538460b9bb8b66bd720ee6237a26858b.svg";
export { ForwardRef as ReactComponent };